import React from "react";
import PerformanceIcon from "../assets/images/icons/perf-ico.svg";
import Profiles from "../assets/images/icons/profile.svg";
import Rakings from "../assets/images/icons/ranking.svg";
import ButtonBG from "../assets/images/icons/button-bg.png";
import { Link } from "react-router-dom";

const MainHome = () => {
  return (
    <div className="h-full text-white flex flex-col justify-between">
      <div className="grid gap-10">
        <h3 className=" max-w-5xl mx-auto">
          By using the QUICKFEET platform, you gain valuable insights into your
          performance, helping you work towards your goals more effectively.
          QUICKFEET is designed to provide targeted, efficient training, making
          the process more enjoyable and engaging. With our platform, you’ll
          stay well-informed about your progress.
        </h3>
        <h3 className="max-w-5xl mx-auto">
          Whether you’re a player, coach, or parent, QUICKFEET allows you to
          analyze performance data and track your progress over selected
          periods. You can assess your development in key skills such as passing
          speed, accuracy, and cognitive abilities. Additionally, you can
          compare your scores with others around the world, giving you a global
          perspective on your growth.
        </h3>
      </div>
      <div className="grid grid-cols-1 tab:grid-cols-3 items-start gap-5 mt-10 text-black max-w-screen-lgs mx-auto">
        <Link
          to="/performance"
          className="flex items-center justify-center cursor-pointer mx-auto max-w-[350px]"
        >
          <div className="relative z-20">
            <img src={PerformanceIcon} alt="Performance-Icon" />
          </div>
          <div className="relative md:-left-[60px] -left-[28px] z-10">
            <img src={ButtonBG} alt="Performance-Icon" />
            <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 font-semibold ml-4 text-lg">
              Performance
            </span>
          </div>
        </Link>
        <Link
          to="/global-ranking"
          className="flex items-center justify-center cursor-pointer mx-auto max-w-[350px]"
        >
          <div className="relative z-20">
            <img src={Rakings} alt="Performance-Icon" />
          </div>
          <div className="relative md:-left-[60px] -left-[28px] z-10">
            <img src={ButtonBG} alt="Performance-Icon" />
            <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 font-semibold ml-4 text-lg whitespace-nowrap">
              Global Ranking
            </span>
          </div>
        </Link>
        <Link
          to="/my-profile"
          className="flex items-center justify-center cursor-pointer mx-auto max-w-[350px]"
        >
          <div className="relative z-20">
            <img src={Profiles} alt="Performance-Icon" />
          </div>
          <div className="relative md:-left-[60px] -left-[28px] z-10">
            <img src={ButtonBG} alt="Performance-Icon" />
            <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 font-semibold ml-4 text-lg">
              My Profile
            </span>
          </div>
        </Link>
      </div>
      <div className="grid justify-center gap-4 text-center mt-10 lg:mt-20">
        <h6 className="font-semibold text-xl">
          Download the QUICKFEET app to connect with the QUICKFEET Trainer:
        </h6>
        <div>
          <p className="font-medium">
            Download the app for Apple{" "}
            <a
              href="https://apps.apple.com/nl/app/quickfeet/id6472891500"
              target="_blank"
              className="text-secondry font-medium"
            >
              here
            </a>
          </p>
          <p className="font-medium">
            Download the app for Android{" "}
            <a
              href="https://play.google.com/store/apps/details?id=com.quick_feet&pli=1"
              target="_blank"
              className="text-secondry font-medium"
            >
              here
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default MainHome;
